var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.06673 15.7195L0.779519 13.4321C-0.25984 12.3929 -0.25984 10.702 0.779519 9.6628L3.36003 7.08213L4.34161 8.06386L1.76109 10.6444C1.26289 11.1426 1.26289 11.9524 1.76109 12.4506L4.04846 14.7378C4.54651 15.236 5.35754 15.2372 5.85575 14.739L8.43626 12.1585L9.41799 13.1401L6.83732 15.7208C6.31784 16.2402 5.63563 16.5 4.95311 16.5C4.27025 16.5 3.58709 16.2399 3.06673 15.7195ZM4.45577 11.0623L10.591 4.92704L11.5726 5.90877L5.43735 12.044L4.45577 11.0623ZM11.6584 8.93642L14.239 6.35575C14.7372 5.85754 14.736 5.04651 14.2378 4.54846L11.9504 2.26109C11.4522 1.76289 10.6426 1.76289 10.1444 2.26109L7.56386 4.84176L6.58213 3.86003L9.16264 1.27952C10.202 0.24016 11.8928 0.24016 12.9321 1.27952L15.2193 3.56689C16.26 4.60734 16.26 6.29812 15.2206 7.33748L12.6401 9.91799L11.6584 8.93642Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIcon);
export default __webpack_public_path__ + "static/media/externalLinkIcon.115c75a42b3cbd855c397e7dd9787e03.svg";
export { ForwardRef as ReactComponent };